import { createContext } from "react";

// Safe default: consumers rendered outside the Provider (or before it mounts) get
// an empty-but-destructurable shape instead of undefined (prevents hard crashes).
export const UserContext = createContext({
  userToken: "",
  userName: "",
  setUserName: () => {},
  loading: false,
  accessDenied: false,
});
